import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ElevatingRealEstateValue from "./sections/ElevatingRealEstateValue";
import TheLorenzoAdvantage from "./sections/TheLorenzoAdvantage";
import TailoredRealEstateSolutions from "./sections/TailoredRealEstateSolutions";
import FeaturedInfillProjects from "./sections/FeaturedInfillProjects";
import VoicesOfSuccess from "./sections/VoicesOfSuccess";
import StartYourNextVenture from "./sections/StartYourNextVenture";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ElevatingRealEstateValue />
      <TheLorenzoAdvantage />
      <TailoredRealEstateSolutions />
      <FeaturedInfillProjects />
      <VoicesOfSuccess />
      <StartYourNextVenture />
      <Footer />
    </div>;
}